import { PropsWithChildren, useMemo } from 'react';

import { useCountryRiskLevels } from 'api/requests/country';

import { CountryRiskContext } from './countryRiskContext';
import { CountryRiskRole } from './types';

interface CountryRiskProviderProps extends PropsWithChildren {
  role: CountryRiskRole;
  /** Creation moment of a questionnaire version: its risk levels are shown */
  at?: Date;
}

/** Enables country badges inside and sets the role of the questionnaire */
export const CountryRiskProvider = ({
  children,
  role,
  at,
}: CountryRiskProviderProps) => {
  const { countryRiskLevels } = useCountryRiskLevels(at);

  const value = useMemo(
    () => ({ role, countryRiskLevels }),
    [role, countryRiskLevels]
  );

  return (
    <CountryRiskContext.Provider value={value}>
      {children}
    </CountryRiskContext.Provider>
  );
};
